import { Button } from 'components/Button/Button';

import './AdminHeader.scss';
import { useHeaderVM } from '../useHeaderVM';
import arrowPrev from 'assets/images/icons/arrow-prev.svg';
import { useNavigate } from 'react-router-dom';
import { Notification } from 'components/Notification/Notification';

export type AdminHeaderProps = {
    title: string;
    backButton?: boolean;
    backButtonLink?: string;
};

export const AdminHeader: React.FC<AdminHeaderProps> = ({ title, backButton, backButtonLink }) => {
    const { handleLogout, user } = useHeaderVM();
    const navigate = useNavigate();

    const handleBackButton = () => {
        (backButtonLink == "") && navigate(-1);
        (backButtonLink && backButtonLink != "") && navigate(backButtonLink);
    };

    return (
        <div className="admin-header">
            <div className="header-title">
                {backButton && <img src={arrowPrev} alt="Retour à la page précédente" onClick={handleBackButton} />}
                <h4>{title}</h4>
            </div>
            <div className="paperplane"></div>
            <div className="authentication">
                <Notification />
                <p className="username">{user?.fullname}</p>
                <Button label="Déconnexion" variant="light" callback={handleLogout}></Button>
            </div>
        </div>
    );
};
